import { Link } from "react-location";
import { useTranslation } from "react-i18next";

const _404Layout = () => {
    const { t } = useTranslation();

    return (
        <div className="h-screen">
            <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
                <div className="max-w-max mx-auto">
                    <main className="sm:flex">
                        <p className="text-4xl font-extrabold text-primary-600 sm:text-5xl">
                            404
                        </p>
                        <div className="sm:ml-6">
                            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                                <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                                    {t("errors.page_not_found")}
                                </h1>
                                <p className="mt-1 text-base text-gray-500">
                                    {t("errors.page_not_found_description")}
                                </p>
                            </div>
                            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                                <Link
                                    to={"/"}
                                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                                    {t("errors.go_back_home")}
                                </Link>
                                <a
                                    href="mailto:support@subsenterprise.com"
                                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-700 bg-primary-100 hover:bg-primary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                                    {t("errors.contact_support")}
                                </a>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default _404Layout;
